'use client'
import React from 'react'
import { Box } from '@mui/material'
import { theme } from '@/modules/shared/ui/kit/theme'

export default function GradPrimaryBrandBackground() {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: theme.palette.gradPrimaryBrand(),
        zIndex: 0,
        mixBlendMode: 'multiply',
      }}
    />
  )
}
